type Listener<T> = (payload: T) => void;

export class EventDispatcher<T> {
  private readonly listeners = new Set<Listener<T>>();

  public addListener(listener: Listener<T>): void {
    this.listeners.add(listener);
  }

  public removeListener(listener: Listener<T>): void {
    this.listeners.delete(listener);
  }

  public removeAllListeners(): void {
    this.listeners.clear();
  }

  public dispatch(payload: T): void {
    for (const listener of this.listeners) {
      listener(payload);
    }
  }
}
